// ============================================================================
// Entity: Settings
// Key: settings
// Kind: settings
// Generated file. Do not edit manually.
// ============================================================================

import {
	getSettingsSettingsContactLoadQueryKey,
	getSettingsSettingsContactLoadQueryOptions,
	getSettingsSettingsGeneralLoadQueryKey,
	getSettingsSettingsGeneralLoadQueryOptions,
	getSettingsSettingsLoginLoadQueryKey,
	getSettingsSettingsLoginLoadQueryOptions,
	getSettingsSettingsPhoneLoadQueryKey,
	getSettingsSettingsPhoneLoadQueryOptions,
	getSettingsSettingsRecordingLoadQueryKey,
	getSettingsSettingsRecordingLoadQueryOptions,
	getSettingsSettingsSetclipLoadQueryKey,
	getSettingsSettingsSetclipLoadQueryOptions,
	settingsSettingsContactReset,
	settingsSettingsContactUpdate,
	settingsSettingsGeneralReset,
	settingsSettingsGeneralUpdate,
	settingsSettingsLoginReset,
	settingsSettingsLoginUpdate,
	settingsSettingsPhoneReset,
	settingsSettingsPhoneUpdate,
	settingsSettingsRecordingReset,
	settingsSettingsRecordingUpdate,
	settingsSettingsSetclipReset,
	settingsSettingsSetclipUpdate,
} from '../api/backstage'
// #region Imports
import type {
	ContactSettingsDto,
	CreateOrUpdateContactSettingsRequest,
	CreateOrUpdateGeneralSettingsRequest,
	CreateOrUpdateLoginSettingsRequest,
	CreateOrUpdatePhoneSettingsRequest,
	CreateOrUpdateRecordingSettingsRequest,
	CreateOrUpdateSetClipSettingsRequest,
	GeneralSettingsDto,
	LoginSettingsDto,
	PhoneSettingsDto,
	RecordingSettingsDto,
	SetClipSettingsDto,
} from '../api/backstage.schemas'
import type { SettingsEntityConfig } from './entity-config.types'
import {
	defineMutationEndpoint,
	defineQueryEndpoint,
} from './entity-config.types'

// #endregion

// #region Settings Sections
const settingsSettings = {
	key: 'settings',
	defaultSection: 'contact',
	sections: {
		contact: {
			key: 'contact',
			endpoints: {
				load: defineQueryEndpoint<ContactSettingsDto, undefined, undefined>({
					key: 'settings.settings.contact.load',
					method: 'GET',
					path: '/admin/settings/contact',
					queryKey: (_args) => getSettingsSettingsContactLoadQueryKey(),
					queryOptions: (_args) => getSettingsSettingsContactLoadQueryOptions(),
				}),
				reset: defineMutationEndpoint<ContactSettingsDto, undefined, undefined>(
					{
						key: 'settings.settings.contact.reset',
						method: 'DELETE',
						path: '/admin/settings/contact',
						mutationOptions: () => ({
							mutationFn: () => settingsSettingsContactReset(),
						}),
						invalidates: [
							(_context) => getSettingsSettingsContactLoadQueryKey(),
						],
					},
				),
				update: defineMutationEndpoint<
					ContactSettingsDto,
					CreateOrUpdateContactSettingsRequest,
					undefined
				>({
					key: 'settings.settings.contact.update',
					method: 'PUT',
					path: '/admin/settings/contact',
					mutationOptions: () => ({
						mutationFn: (variables: {
							data: CreateOrUpdateContactSettingsRequest
						}) => settingsSettingsContactUpdate(variables.data),
					}),
					invalidates: [(_context) => getSettingsSettingsContactLoadQueryKey()],
				}),
			},
		},
		general: {
			key: 'general',
			endpoints: {
				load: defineQueryEndpoint<GeneralSettingsDto, undefined, undefined>({
					key: 'settings.settings.general.load',
					method: 'GET',
					path: '/admin/settings/general',
					queryKey: (_args) => getSettingsSettingsGeneralLoadQueryKey(),
					queryOptions: (_args) => getSettingsSettingsGeneralLoadQueryOptions(),
				}),
				reset: defineMutationEndpoint<GeneralSettingsDto, undefined, undefined>(
					{
						key: 'settings.settings.general.reset',
						method: 'DELETE',
						path: '/admin/settings/general',
						mutationOptions: () => ({
							mutationFn: () => settingsSettingsGeneralReset(),
						}),
						invalidates: [
							(_context) => getSettingsSettingsGeneralLoadQueryKey(),
						],
					},
				),
				update: defineMutationEndpoint<
					GeneralSettingsDto,
					CreateOrUpdateGeneralSettingsRequest,
					undefined
				>({
					key: 'settings.settings.general.update',
					method: 'PUT',
					path: '/admin/settings/general',
					mutationOptions: () => ({
						mutationFn: (variables: {
							data: CreateOrUpdateGeneralSettingsRequest
						}) => settingsSettingsGeneralUpdate(variables.data),
					}),
					invalidates: [(_context) => getSettingsSettingsGeneralLoadQueryKey()],
				}),
			},
		},
		login: {
			key: 'login',
			endpoints: {
				load: defineQueryEndpoint<LoginSettingsDto, undefined, undefined>({
					key: 'settings.settings.login.load',
					method: 'GET',
					path: '/admin/settings/login',
					queryKey: (_args) => getSettingsSettingsLoginLoadQueryKey(),
					queryOptions: (_args) => getSettingsSettingsLoginLoadQueryOptions(),
				}),
				reset: defineMutationEndpoint<LoginSettingsDto, undefined, undefined>({
					key: 'settings.settings.login.reset',
					method: 'DELETE',
					path: '/admin/settings/login',
					mutationOptions: () => ({
						mutationFn: () => settingsSettingsLoginReset(),
					}),
					invalidates: [(_context) => getSettingsSettingsLoginLoadQueryKey()],
				}),
				update: defineMutationEndpoint<
					LoginSettingsDto,
					CreateOrUpdateLoginSettingsRequest,
					undefined
				>({
					key: 'settings.settings.login.update',
					method: 'PUT',
					path: '/admin/settings/login',
					mutationOptions: () => ({
						mutationFn: (variables: {
							data: CreateOrUpdateLoginSettingsRequest
						}) => settingsSettingsLoginUpdate(variables.data),
					}),
					invalidates: [(_context) => getSettingsSettingsLoginLoadQueryKey()],
				}),
			},
		},
		phone: {
			key: 'phone',
			endpoints: {
				load: defineQueryEndpoint<PhoneSettingsDto, undefined, undefined>({
					key: 'settings.settings.phone.load',
					method: 'GET',
					path: '/admin/settings/phone',
					queryKey: (_args) => getSettingsSettingsPhoneLoadQueryKey(),
					queryOptions: (_args) => getSettingsSettingsPhoneLoadQueryOptions(),
				}),
				reset: defineMutationEndpoint<PhoneSettingsDto, undefined, undefined>({
					key: 'settings.settings.phone.reset',
					method: 'DELETE',
					path: '/admin/settings/phone',
					mutationOptions: () => ({
						mutationFn: () => settingsSettingsPhoneReset(),
					}),
					invalidates: [(_context) => getSettingsSettingsPhoneLoadQueryKey()],
				}),
				update: defineMutationEndpoint<
					PhoneSettingsDto,
					CreateOrUpdatePhoneSettingsRequest,
					undefined
				>({
					key: 'settings.settings.phone.update',
					method: 'PUT',
					path: '/admin/settings/phone',
					mutationOptions: () => ({
						mutationFn: (variables: {
							data: CreateOrUpdatePhoneSettingsRequest
						}) => settingsSettingsPhoneUpdate(variables.data),
					}),
					invalidates: [(_context) => getSettingsSettingsPhoneLoadQueryKey()],
				}),
			},
		},
		recording: {
			key: 'recording',
			endpoints: {
				load: defineQueryEndpoint<RecordingSettingsDto, undefined, undefined>({
					key: 'settings.settings.recording.load',
					method: 'GET',
					path: '/admin/settings/recording',
					queryKey: (_args) => getSettingsSettingsRecordingLoadQueryKey(),
					queryOptions: (_args) =>
						getSettingsSettingsRecordingLoadQueryOptions(),
				}),
				reset: defineMutationEndpoint<
					RecordingSettingsDto,
					undefined,
					undefined
				>({
					key: 'settings.settings.recording.reset',
					method: 'DELETE',
					path: '/admin/settings/recording',
					mutationOptions: () => ({
						mutationFn: () => settingsSettingsRecordingReset(),
					}),
					invalidates: [
						(_context) => getSettingsSettingsRecordingLoadQueryKey(),
					],
				}),
				update: defineMutationEndpoint<
					RecordingSettingsDto,
					CreateOrUpdateRecordingSettingsRequest,
					undefined
				>({
					key: 'settings.settings.recording.update',
					method: 'PUT',
					path: '/admin/settings/recording',
					mutationOptions: () => ({
						mutationFn: (variables: {
							data: CreateOrUpdateRecordingSettingsRequest
						}) => settingsSettingsRecordingUpdate(variables.data),
					}),
					invalidates: [
						(_context) => getSettingsSettingsRecordingLoadQueryKey(),
					],
				}),
			},
		},
		setclip: {
			key: 'setclip',
			endpoints: {
				load: defineQueryEndpoint<SetClipSettingsDto, undefined, undefined>({
					key: 'settings.settings.setclip.load',
					method: 'GET',
					path: '/admin/settings/setclip',
					queryKey: (_args) => getSettingsSettingsSetclipLoadQueryKey(),
					queryOptions: (_args) => getSettingsSettingsSetclipLoadQueryOptions(),
				}),
				reset: defineMutationEndpoint<SetClipSettingsDto, undefined, undefined>(
					{
						key: 'settings.settings.setclip.reset',
						method: 'DELETE',
						path: '/admin/settings/setclip',
						mutationOptions: () => ({
							mutationFn: () => settingsSettingsSetclipReset(),
						}),
						invalidates: [
							(_context) => getSettingsSettingsSetclipLoadQueryKey(),
						],
					},
				),
				update: defineMutationEndpoint<
					SetClipSettingsDto,
					CreateOrUpdateSetClipSettingsRequest,
					undefined
				>({
					key: 'settings.settings.setclip.update',
					method: 'PUT',
					path: '/admin/settings/setclip',
					mutationOptions: () => ({
						mutationFn: (variables: {
							data: CreateOrUpdateSetClipSettingsRequest
						}) => settingsSettingsSetclipUpdate(variables.data),
					}),
					invalidates: [(_context) => getSettingsSettingsSetclipLoadQueryKey()],
				}),
			},
		},
	},
} as const
// #endregion

// #region Entity Config Export
export const settingsEntityConfig = {
	key: 'settings',
	kind: 'settings',
	routePath: '/settings',
	settings: settingsSettings,
} as const satisfies SettingsEntityConfig<'settings'>
// #endregion
